(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marvel-hero-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /**
     * Initialize Marvel Hero Slider
     * @param {HTMLElement} sectionMdl - The section element
     */
    function initMarvelSliderMdl(sectionMdl) {
      // Prevent double initialization
      if (!sectionMdl || sectionMdl.dataset.sliderInitialized === 'true') return;
      sectionMdl.dataset.sliderInitialized = 'true';

      const sliderMdl = sectionMdl.querySelector('[data-slider]');
      if (!sliderMdl) return;

      const trackMdl = sliderMdl.querySelector('[data-track]');
      const slidesMdl = Array.from(sliderMdl.querySelectorAll('[data-slide]'));
      const dotsMdl = Array.from(sectionMdl.querySelectorAll('[data-dot]'));

      // Exit if no track or only one slide
      if (!trackMdl || slidesMdl.length <= 1) return;

      // Configuration from data attributes
      const autoplayEnabledMdl = sectionMdl.dataset.autoplay === 'true';
      const autoplaySpeedMdl = parseInt(sectionMdl.dataset.autoplaySpeed, 10) || 5000;

      // State variables
      let currentIndexMdl = 0;
      let autoplayTimerMdl = null;
      let isDraggingMdl = false;
      let dragStartXMdl = 0;
      let dragDeltaXMdl = 0;
      let slideWidthMdl = 0;

      /**
       * Navigate to specific slide with animation
       * @param {number} indexMdl - Target slide index
       */
      function goToSlideMdl(indexMdl) {
        // Handle loop around
        if (indexMdl < 0) indexMdl = slidesMdl.length - 1;
        if (indexMdl >= slidesMdl.length) indexMdl = 0;

        currentIndexMdl = indexMdl;
        trackMdl.style.transform = 'translateX(-' + indexMdl * 100 + '%)';

        // Update pagination dots
        dotsMdl.forEach(function (dotMdl, iMdl) {
          const isActiveMdl = iMdl === indexMdl;
          dotMdl.classList.toggle('is-active', isActiveMdl);
          dotMdl.setAttribute('aria-selected', isActiveMdl ? 'true' : 'false');
        });

        // Update slides aria-hidden for accessibility
        slidesMdl.forEach(function (slideMdl, iMdl) {
          slideMdl.setAttribute('aria-hidden', iMdl === indexMdl ? 'false' : 'true');
        });
      }

      /**
       * Move to next slide
       */
      function nextSlideMdl() {
        goToSlideMdl(currentIndexMdl + 1);
      }

      /**
       * Start autoplay timer
       */
      function startAutoplayMdl() {
        if (!autoplayEnabledMdl) return;
        stopAutoplayMdl();
        autoplayTimerMdl = setInterval(nextSlideMdl, autoplaySpeedMdl);
      }

      /**
       * Stop autoplay timer
       */
      function stopAutoplayMdl() {
        if (autoplayTimerMdl) {
          clearInterval(autoplayTimerMdl);
          autoplayTimerMdl = null;
        }
      }

      // Pause autoplay on hover/focus
      sliderMdl.addEventListener('mouseenter', stopAutoplayMdl);
      sliderMdl.addEventListener('mouseleave', startAutoplayMdl);
      sliderMdl.addEventListener('focusin', stopAutoplayMdl);
      sliderMdl.addEventListener('focusout', startAutoplayMdl);

      // Pause autoplay when tab is hidden
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplayMdl();
        } else {
          startAutoplayMdl();
        }
      });

      // Dot click navigation
      dotsMdl.forEach(function (dotMdl) {
        dotMdl.addEventListener('click', function () {
          const targetIndexMdl = parseInt(dotMdl.dataset.index, 10);
          goToSlideMdl(targetIndexMdl);
          stopAutoplayMdl();
          startAutoplayMdl();
        });
      });
      // Arrow button navigation
      const prevBtnMdl = sectionMdl.querySelector('[data-prev]');
      const nextBtnMdl = sectionMdl.querySelector('[data-next]');

      if (prevBtnMdl) {
        prevBtnMdl.addEventListener('click', function () {
          goToSlideMdl(currentIndexMdl - 1);
          stopAutoplayMdl();
          startAutoplayMdl();
        });
      }

      if (nextBtnMdl) {
        nextBtnMdl.addEventListener('click', function () {
          goToSlideMdl(currentIndexMdl + 1);
          stopAutoplayMdl();
          startAutoplayMdl();
        });
      }

      // Keyboard navigation (Arrow keys)
      sliderMdl.addEventListener('keydown', function (eMdl) {
        if (eMdl.key === 'ArrowLeft') {
          eMdl.preventDefault();
          goToSlideMdl(currentIndexMdl - 1);
          stopAutoplayMdl();
          startAutoplayMdl();
        } else if (eMdl.key === 'ArrowRight') {
          eMdl.preventDefault();
          goToSlideMdl(currentIndexMdl + 1);
          stopAutoplayMdl();
          startAutoplayMdl();
        }
      });

      /**
       * Get pointer X position (mouse or touch)
       */
      function getPointerXMdl(eMdl) {
        return eMdl.touches ? eMdl.touches[0].clientX : eMdl.clientX;
      }

      /**
       * Drag/Swipe start handler
       */
      function onDragStartMdl(eMdl) {
        isDraggingMdl = true;
        dragStartXMdl = getPointerXMdl(eMdl);
        dragDeltaXMdl = 0;
        slideWidthMdl = sliderMdl.offsetWidth;
        trackMdl.classList.add('is-dragging');
        stopAutoplayMdl();
      }

      /**
       * Drag/Swipe move handler
       */
      function onDragMoveMdl(eMdl) {
        if (!isDraggingMdl) return;
        dragDeltaXMdl = getPointerXMdl(eMdl) - dragStartXMdl;
        const offsetPercentMdl = (dragDeltaXMdl / slideWidthMdl) * 100;
        trackMdl.style.transform = 'translateX(calc(-' + currentIndexMdl * 100 + '% + ' + offsetPercentMdl + '%))';
      }

      /**
       * Drag/Swipe end handler
       */
      function onDragEndMdl() {
        if (!isDraggingMdl) return;
        isDraggingMdl = false;
        trackMdl.classList.remove('is-dragging');

        // Calculate swipe threshold (20% of slide width or minimum 50px)
        const thresholdMdl = Math.max(slideWidthMdl * 0.2, 50);

        if (dragDeltaXMdl < -thresholdMdl) {
          goToSlideMdl(currentIndexMdl + 1);
        } else if (dragDeltaXMdl > thresholdMdl) {
          goToSlideMdl(currentIndexMdl - 1);
        } else {
          goToSlideMdl(currentIndexMdl);
        }

        startAutoplayMdl();
      }

      // Touch/Swipe event listeners
      sliderMdl.addEventListener('touchstart', onDragStartMdl, { passive: true });
      sliderMdl.addEventListener('touchmove', onDragMoveMdl, { passive: true });
      sliderMdl.addEventListener('touchend', onDragEndMdl);
      sliderMdl.addEventListener('touchcancel', onDragEndMdl);

      // Initialize slider to first slide
      goToSlideMdl(0);
      startAutoplayMdl();

      // Shopify Theme Editor Support: Block selection
      document.addEventListener('shopify:block:select', function (eMdl) {
        if (sectionMdl.contains(eMdl.target)) {
          const slideIndexMdl = slidesMdl.findIndex(function (sMdl) {
            return sMdl.contains(eMdl.target);
          });
          if (slideIndexMdl >= 0) {
            goToSlideMdl(slideIndexMdl);
            stopAutoplayMdl();
          }
        }
      });

      document.addEventListener('shopify:block:deselect', function (eMdl) {
        if (sectionMdl.contains(eMdl.target)) {
          startAutoplayMdl();
        }
      });
    }

    /**
     * Initialize all Marvel Hero sections on the page
     */
    function initAllMdl() {
      document.querySelectorAll('.marvel-hero-showcase-mdl').forEach(initMarvelSliderMdl);
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllMdl);
    } else {
      initAllMdl();
    }

    // Reinitialize on Shopify section load (theme editor)
    document.addEventListener('shopify:section:load', function (eMdl) {
      const reloadedSectionMdl = eMdl.target.querySelector('.marvel-hero-showcase-mdl');
      if (reloadedSectionMdl) {
        initMarvelSliderMdl(reloadedSectionMdl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
